<template>
    <div>
        <v-container max-width="2500" style="max-width: 3000px !important">
            <v-card class="mx-auto my-5" max-width="2500">
                <v-system-bar class="py-5 px-3" color="#1973a5" style="color: #fff" dark>
                    Lista de instaladores
                </v-system-bar>
            </v-card>
            <v-card class="mx-auto my-5 elevation-1" max-width="2100">
                <v-row>
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field max-width="200" class="mx-3" v-model="searchNombre" label="Nombre"
                            prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line
                            @input="dataInit"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field max-width="200" class="mx-3" v-model="searchDescripcion" label="Descripción"
                            prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line
                            @input="dataInit"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="5" md="5" class="mx-3">
                        <v-btn color="#1973a5" dark class="mb-2" @click="createOpen" style="margin-top: 1rem">
                            Nuevo
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="mx-auto my-5" max-width="2500">
                <div style="max-height: 70vh; overflow-y: scroll">
                    <v-data-table :headers="headers" :items="filteredData" class="elevation-1" :sort-by.sync="sortBy"
                        :loading="isLoading" loading-text="Cargando... Por favor espere">
                        <template v-slot:[`item.imagen`]="{ item }">
                            <div style="position: relative;">
                                <img :src=item.imagen class="imagen-install">
                            </div>
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-tooltip bottom color="success">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon small class="mr-3" v-bind="attrs" v-on="on" @click="descargaArchivo(item)">
                                        mdi-cloud-download
                                    </v-icon>
                                </template>
                                <span>Descargar</span>
                            </v-tooltip>
                            <v-tooltip bottom color="error">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon small class="mr-3" v-bind="attrs" v-on="on" @click="deleteOpen(item)">
                                        mdi-delete
                                    </v-icon>
                                </template>
                                <span>Eliminar</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </div>
                <v-dialog v-model="dialogEdit" v-if="dialogEdit" max-width="1000px">
                    <formInstaladores @editClose="editClose" :idItem="idItem" @openAsigCupo="openAsigCupo">
                    </formInstaladores>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                        <v-card-title class="text-h5">¿Esta seguro de eliminar registro?</v-card-title>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="deleteClose">Cancel</v-btn>
                            <v-btn color="blue darken-1" text @click="deleteItem">OK</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-card>
            <v-dialog v-model="dialogLoader" hide-overlay persistent width="300" class="fondo-griss">
                <v-card color="primary" dark>
                    <v-card-text>
                        Cargando Datos
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
</template>
<style>
.imagen-install {
    z-index: 0;
    height: 2rem;
    position: revert;
}

.imagen-install:hover {
    z-index: 99;
    position: absolute;
    height: 6rem;
    left: 3rem;
    top: -3rem;
}

.bg-primary-table {
    /* background: rgb(27 160 255 / 12%); */
    font-weight: 400;
}

.text-start {
    font-size: 0.8rem !important;
}

.container {
    max-width: 3000px !important;
}
</style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";
import formInstaladores from "./form.vue"
export default {
    data() {
        return {
            dialogLoader: false,
            polygonOptions: {
                strokeColor: '#FF0000', // Color del borde
                strokeOpacity: 0.1,     // Opacidad del borde
                strokeWeight: 0.1,        // Grosor del borde
                fillColor: '#FF0000',   // Color de relleno
                fillOpacity: 0.35       // Opacidad de relleno
            },
            marcadores: [
                {
                    posicion: { lat: -12.074928851253814, lng: -77.04316187097396 },
                    nombre_completo: 'Ubique al \\n paciente'
                },
            ],
            e1: 1,
            step: 1,
            itemsUbigeo: [],
            itemsDepartamento: [],
            itemsDistrito: [],
            itemsProvincia: [],
            dataHospital: [],
            dataMedico: [],
            dialogAsignarCupo: false,
            dialogCargaMasiva: false,
            valor1: 15,
            valor2: 10,
            ver: false,
            searchDescripcion: "",
            searchNombre: "",
            dataPaciente: [],
            dataEnvio: {
                fecha: null,
            },
            titleButton: "",
            titleCard: "",
            valid: true,
            pacienteData: {
                tipo_doc: null,
                num_doc: null,
                nombres: null,
                ape_pat: null,
                ape_mat: null,
                fecha_nac: null,
                cas: null,
                estado: 1,
                sexo: null,
                cordePacForm: null,
                latitud: null,
                longitud: null,
                direccion: null,
                distrito: null,
                user_id: null,
                cordePac: null,
                telefono: null,
                telefonoAlterno: null,
                departamento: null,
                provincia: null,
                ubigeo_id: null,
                medico_id: null,
                hospital_id: null,
                fecha_ultima_dialisis: null,
                serologia: null,
                pacienteId: null
            },
            cas: null,
            maestro: null,
            deleteUser: [],
            statusEdit: false,
            date: new Date()
                .toISOString()
                .substr(0, 10),
            date1: new Date()
                .toISOString()
                .substr(0, 10),
            search: "",
            sortBy: [{ key: "cupos_disponible", order: "asc" }],
            headers: [
                { text: "Nombre", value: "nombre" },
                { text: "Descripción", value: "descripcion" },
                { text: "Imagen", value: "imagen", align: "center" },
                { text: "Fec. Modificación", value: "fecha_modificacion" },
                { text: "Actions", align: "center", value: "actions", sortable: false },
            ],
            dialogEdit: false,
            dialogDelete: false,
            dataCas: [],
            dataMaesto: [],
            isLoading: false,
            itemsTipSex: ["MASCULINO", "FEMENINO"],
            menu: false,
            menu1: false,
            date: new Date().toISOString().substr(0, 10),
            itemsPacientes: [],
            arraySerologia: [{ value: "positivo", label: "Positivo" }, { value: "negativo", label: "Negativo" }],
            pacienteRegistrado: [],
            idItem: null
        };

    },
    methods: {
        descargaArchivo(item) {
            // Verifica que `item.imagen` tenga la URL correcta del archivo
            const link = document.createElement('a');
            link.href = item.archivo; // URL del archivo a descargar
            link.download = item.archivo.split('/').pop(); // Nombre del archivo para la descarga
            link.target = '_blank'; // Opcional: abre en una nueva pestaña
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        openAsigCupo(item) {
            console.log("esta golpeando 1234");
            this.pacienteRegistrado = item;
            this.dialogAsignarCupo = true;
        },
        downloadExcel() {
            const XLSXStyle = require("xlsx-js-style");

            // STEP 1: Create a new workbook
            const wb = XLSXStyle.utils.book_new();

            // STEP 2: Create data rows and styles
            const headers = [
                { text: "tipo_doc", cell: "A1", style: true },
                { text: "num_doc", cell: "B1", style: true },
                { text: "ape_pat", cell: "C1", style: true },
                { text: "ape_mat", cell: "D1", style: true },
                { text: "nombres", cell: "E1", style: true },
                { text: "fecha_nac", cell: "F1", style: true },
                { text: "sexo", cell: "G1", style: true },
                { text: "cas_id", cell: "H1", style: true },
                { text: "cordepac", cell: "I1", style: true },
                { text: "direccion", cell: "J1", style: true },
                { text: "distrito", cell: "K1", style: true }
            ];
            // STEP 3: Create worksheet with rows; Add worksheet to workbook
            const ws = XLSXStyle.utils.aoa_to_sheet([]);
            for (let i = 0; i < headers.length; i++) {
                const element = headers[i];
                XLSXStyle.utils.sheet_add_aoa(ws, [[element.text]], {
                    origin: element.cell,
                });
                ws[element.cell].s = {
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } }, // Bordes superior
                        bottom: { style: "thin", color: { rgb: "000000" } }, // Bordes inferior
                        left: { style: "thin", color: { rgb: "000000" } }, // Bordes izquierdo
                        right: { style: "thin", color: { rgb: "000000" } }, // Bordes derecho
                    },
                    alignment: { wrapText: true },
                };
                if (element.style) {
                    ws[element.cell].s = {
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } }, // Bordes superior
                            bottom: { style: "thin", color: { rgb: "000000" } }, // Bordes inferior
                            left: { style: "thin", color: { rgb: "000000" } }, // Bordes izquierdo
                            right: { style: "thin", color: { rgb: "000000" } }, // Bordes derecho
                        },
                        alignment: {
                            horizontal: "center",
                            vertical: "center",
                            wrapText: true,
                        },
                    };
                }
            }



            XLSXStyle.utils.book_append_sheet(wb, ws, "readme demo");

            // STEP 4: Write Excel file to browser
            const excelBuffer = XLSXStyle.write(wb, {
                bookType: "xlsx",
                type: "array",
            });
            const blob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "Formato_registro_paciente.xlsx";
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        },
        cargaMasivaOpen() {
            this.dialogCargaMasiva = true;
        },
        cargaMasivaClose() {
            this.dialogCargaMasiva = false;
            this.dataInit();
        },
        createOpen() {
            this.idItem = null;
            this.dialogEdit = true;
        },
        editOpen(item) {
            this.idItem = item;
            this.statusEdit = true;
            this.dialogEdit = true;
        },
        editClose() {
            this.dialogEdit = false;
            this.idItem = null;
            this.dataInit();
        },
        deleteOpen(item) {
            this.deleteUser = item;
            this.dialogDelete = true;
        },
        deleteClose() {
            this.dialogDelete = false;
        },
        deleteItem() {
            axios
                .post("http://10.0.52.64:8000/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .delete(
                            "http://10.0.52.64:8000/instaladores/" + this.deleteUser.url.split("/")[4] + "/",
                            {
                                headers: { Authorization: this.auth },
                            }
                        )
                        .then((res) => {
                            this.dialogDelete = false;
                            this.dataInit();
                            this.dialogEdit = false;
                        })
                        .catch((res) => {
                            console.warn("Error:", res);
                            this.dialogDelete = false;
                            this.dialog = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        dataInit() {
            this.isLoading = true;
            axios
                .post("http://10.0.52.64:8000/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get("http://10.0.52.64:8000/instaladores/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.isLoading = false;
                            this.dataPaciente = res.data;
                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        loadCas() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/cas/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dataCas = res.data;
                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
        },
        loadHospital() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/hospital/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dataHospital = res.data;
                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        loadMaestro() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/maestro/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dataMaesto = res.data;
                            this.dataMaesto = res.data.filter(
                                (e) =>
                                    e.codMaestro == "ND001"
                            );
                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        formatearFecha(fecha) {
            // Dividir la fecha en partes: año, mes y día
            const partes = fecha.split("-");
            // Crear una nueva fecha con el formato "mm-dd-yyyy"
            const nuevaFecha = new Date(`${partes[1]}/${partes[2]}/${partes[0]}`);
            // Obtener el mes, día y año de la nueva fecha
            const mes = nuevaFecha.getMonth() + 1;
            const dia = nuevaFecha.getDate();
            const año = nuevaFecha.getFullYear();
            // Formatear la fecha en el formato deseado
            return `${mes.toString().padStart(2, "0")}-${dia
                .toString()
                .padStart(2, "0")}-${año}`;
        },
        clearForm() {
            this.pacienteData = {
                tipo_doc: null,
                num_doc: null,
                nombres: null,
                ape_pat: null,
                ape_mat: null,
                fecha_nac: null,
                cas: null,
                estado: 1,
                sexo: null,
                cordePac: null,
                latitud: null,
                longitud: null,
                direccion: null,
                distrito: null,
                user_id: null,
                telefonoAlterno: null,
                telefono: null,
                ubigeo_id: null,
                medico_id: null,
                hospital_id: null,
                serologia: null
            };
            this.date = null;
            this.cas = null;
            this.maestro = null;
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
    },
    computed: {
        computedDateFormatted() {
            return this.formatDate(this.date);
        },
        computedDateFormatted1() {
            return this.formatDate(this.date1);
        },
        dataCasOptions() {
            // Formatear los elementos del objeto según lo requerido por v-select
            return this.dataCas.map((item) => ({
                text: item.descripCas,
                value: item.url,
            }));
        },
        itemClass() {
            return (item) => {
                if (item.cupos_disponible === 0) {
                    return ""; // Aplica la clase "bg-primary" para el color #007bff
                } else {
                    return "bg-primary-table primary--text"; // No se aplica ninguna clase
                }
            };
        },
        filteredData() {
            if (!this.searchNombre && !this.searchDescripcion) {
                return this.dataPaciente;
            }
            let filtered = this.dataPaciente;
            if (this.searchNombre) {
                filtered = filtered.filter((item) =>
                    item.nombre
                        .toLowerCase()
                        .includes(this.searchNombre.toLowerCase())
                );
            }
            if (this.searchDescripcion) {
                filtered = filtered.filter((item) =>
                    item.descripcion
                        .toLowerCase()
                        .includes(this.searchDescripcion.toLowerCase())
                );
            }
            return filtered;
        },
    },
    created() {
        this.dataInit();
    },
    components: {
        formInstaladores
    },
};
</script>